<template>
    <div class="card">
       <div class="bTitle">举报</div>
       <div class="mTitle">举报内容</div>
       <div class="mType">
         <div v-for="(v,i) in reportList" :key="i" style="margin-bottom: 5px;">
            <el-radio v-model="radio" :label="i">{{v.name}}</el-radio>
         </div>
       </div>
       <div class="mTitle">举报描述</div>
       <div class="mDesc">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
       </div>
       <div class="submitBtn">
        <el-button type="primary" @click="subFun">提交</el-button>
       </div>
    </div>
</template>

<script>
import {report} from '@/api/user'
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        chatUserInfo:{
            type:Object,
            default: () => { }
        }
    },
    components: {},
    data() {
        return {
            reportList:[{
                name:'Adult or nudity',
                key:'adult'
            }
            // ,{
            //     name:'版权或商标侵权',
            //     key:''
            // },{
            //     name:'禁止的产品和服务',
            //     key:''
            // },{
            //     name:'成人或裸露',
            //     key:''
            // },{
            //     name:'垃圾邮件或欺诈',
            //     key:''
            // },{
            //     name:'其他条款和条件违规',
            //     key:''
            // },{
            //     name:'虚假资料',
            //     key:''
            // }
        ],
            radio: '1',
            textarea:''
        };
    },
    computed: {
        
    },
    watch: {
        isShow: {
            handler(newVal) {
                if (newVal) {

                }
            },
            immediate: true  // 立即以当前值触发回调
        }
    },
    methods: {
        subFun(){
            console.log(this.chatUserInfo.platformType,this.chatUserInfo.platformUserId,this.chatUserInfo.recId,this.chatUserInfo.platformUserId,this.textarea)
            this.$alert('您是否确认举报该用户12？', '举报提示', {
            confirmButtonText: '确定',
            showCancelButton:'true',
            cancelButtonText:'取消',
            callback: action => {
                if(action=='confirm'){
                    
                // 举报
                //  console.log('123')
                 if(!this.textarea){
                    this.$message.error('请填写举报原因')
                    return
                 }
                 report({
                    platformType: this.chatUserInfo.platformType,
                    platformUserId: this.chatUserInfo.platformUserId,
                    recId:this.chatUserInfo.recId,
                    platformUserId:this.chatUserInfo.platformUserId,
                    reportReason:'adult',
                    reportComment:this.textarea,
                    userId:this.chatUserInfo.userId
                 }).then(res=>{
                    this.$message.success('举报成功')
                        this.$emit('userReportClose',{
                            platformUserId: this.chatUserInfo.platformUserId,
                            recId:this.chatUserInfo.recId,
                            userId:this.chatUserInfo.userId
                        })
                 })
                }else{
                // 取消举报
                    console.log('234')
                }
            }
            });
        },
        checkBType(t){
            if(t == 1){
                this.bType = 1
                this.mType = 1
            }else if(t == 2){
                this.bType = 2
                this.mType = 1
            }
        },
        expandList(val) {
            console.log(val);
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.bTitle{
    font-size: 20px;
    font-weight: 500;
}
.mTitle{
    margin: 10px 0;
}
.mType{
    display: flex;
    max-height: 200px;
    flex-direction: column;
    align-items: flex-start;
    overflow-y: scroll;
    overflow-x: hidden;
}
.submitBtn{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>